import React, { useState } from 'react';
import './DropdownAccessHistory.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

library.add(faCaretDown, faCaretUp);

export function DropdownAccessHistory({
  typeDropdown,
  maxValue,
  setPage,
  setRowsPerPage,
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [choiceItemDropdown, setChoiceItemDropdown] = useState(null);

  function handleOpenCloseDropdown() {
    setIsDropdownOpen(!isDropdownOpen);
  }

  function onItemDropdownClicked(value) {
    setChoiceItemDropdown(value);
    setIsDropdownOpen(false);

    if (typeDropdown === 'changePage') {
      setPage(value);
    }
    if (typeDropdown === 'changeRowsPerPage') {
      setRowsPerPage(value);
    }
  }

  function createListDropdown(typeDropdown, maxValue) {
    if (typeDropdown === 'changePage') {
      return Array.from({ length: maxValue }, (_, i) => i + 1);
    }
    if (typeDropdown === 'changeRowsPerPage') {
      return [maxValue];
    }
  }

  return (
    <div className="dropdownContainer">
      <div
        className={
          isDropdownOpen ? 'dropdownHeaderDropdownOpen' : 'dropdownHeader'
        }
      >
        <div className="textDropdownHeader">
          {choiceItemDropdown ||
            (typeDropdown === 'changeRowsPerPage'
              ? setChoiceItemDropdown(5)
              : setChoiceItemDropdown(1))}
        </div>
        <button className="buttonDropdown" onClick={handleOpenCloseDropdown}>
          {isDropdownOpen ? (
            <FontAwesomeIcon icon="fa-solid fa-caret-up" />
          ) : (
            <FontAwesomeIcon icon="fa-solid fa-caret-down" />
          )}
        </button>
      </div>
      {isDropdownOpen && (
        <div className="dropdownListContainer">
          <div className="dropdownList">
            {createListDropdown(typeDropdown, maxValue).map((option) => (
              <li
                className="dropdownListItem"
                onClick={() => onItemDropdownClicked(option)}
                key={option}
              >
                {option}
              </li>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
